import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-caption font-weight-bold" }
const _hoisted_2 = { class: "d-flex align-center ga-2 mb-3" }
const _hoisted_3 = { class: "d-flex align-center flex-wrap ga-2" }
const _hoisted_4 = {
  key: 1,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_5 = { class: "d-flex align-center flex-wrap ga-2 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ChipSelect = _resolveComponent("ChipSelect")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_FactorySchemaNode = _resolveComponent("FactorySchemaNode")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!

  return (_openBlock(), _createBlock(_component_v_timeline, {
    side: "end",
    density: "compact",
    align: "start",
    "truncate-line": "both",
    class: "ms-steps"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (s, i) => {
        return (_openBlock(), _createBlock(_component_v_timeline_item, {
          key: 's' + i,
          "dot-color": "surface-variant",
          size: "small"
        }, {
          icon: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(i + 1), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              color: "background",
              variant: "elevated",
              elevation: "4",
              rounded: "md",
              class: "pa-4 ms-steps__card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_text_field, {
                    "model-value": s.name,
                    variant: "plain",
                    density: "compact",
                    "hide-details": "",
                    class: "text-h6 font-weight-bold ms-steps__name",
                    "onUpdate:modelValue": (v) => _ctx.patchStep(i, { name: v })
                  }, null, 8, ["model-value", "onUpdate:modelValue"]),
                  _createVNode(_component_Button, {
                    icon: "mdi-trash-can-outline",
                    tooltip: "Remove step",
                    size: "small",
                    click: () => _ctx.removeStep(i)
                  }, null, 8, ["click"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-body-2 text-medium-emphasis" }, "Run", -1)),
                  (s.kind === 'workflow' || _ctx.workflows.length)
                    ? (_openBlock(), _createBlock(_component_ChipSelect, {
                        key: 0,
                        "model-value": s.kind === 'workflow' ? 'workflow' : 'assistant',
                        options: _ctx.kindOptions,
                        "onUpdate:modelValue": (v) => _ctx.setKind(i, v)
                      }, null, 8, ["model-value", "options", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                  (s.kind === 'workflow')
                    ? (_openBlock(), _createBlock(_component_ChipSelect, {
                        key: 1,
                        "model-value": s.workflowName || 'Workflow',
                        options: _ctx.workflowOptions(s.workflowName),
                        icon: "mdi-layers-triple-outline",
                        "onUpdate:modelValue": (v) => _ctx.setWorkflow(i, v)
                      }, null, 8, ["model-value", "options", "onUpdate:modelValue"]))
                    : (_openBlock(), _createBlock(_component_ChipSelect, {
                        key: 2,
                        "model-value": s.agent,
                        options: _ctx.agentOptions(s.agent),
                        icon: "mdi-robot-outline",
                        "onUpdate:modelValue": (v) => _ctx.patchStep(i, { agent: v })
                      }, null, 8, ["model-value", "options", "onUpdate:modelValue"])),
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-body-2 text-disabled" }, "·", -1)),
                  _createVNode(_component_ChipSelect, {
                    "model-value": _ctx.thenLabel(s),
                    options: _ctx.thenOptions,
                    "onUpdate:modelValue": (v) => _ctx.setThen(i, v)
                  }, null, 8, ["model-value", "options", "onUpdate:modelValue"])
                ]),
                (s.kind === 'workflow')
                  ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                      key: 0,
                      variant: "accordion",
                      elevation: "0",
                      class: "mt-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel, { "bg-color": "background" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel_title, { class: "text-body-2" }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode("What this workflow receives")
                              ])),
                              _: 1,
                              __: [2]
                            }),
                            _createVNode(_component_v_expansion_panel_text, null, {
                              default: _withCtx(() => [
                                (_ctx.schemaEditable(s))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-3" }, " The fields this workflow expects as its starting data. Whatever the previous step (or the starting data, if this step runs first) hands over must match. ", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schemaFieldsFor(s, i), (field, fi) => {
                                        return (_openBlock(), _createBlock(_component_FactorySchemaNode, {
                                          key: field.id,
                                          field: field,
                                          depth: 0,
                                          onUpdate: (f) => _ctx.updateSchemaField(i, fi, f),
                                          onDelete: ($event: any) => (_ctx.removeSchemaField(i, fi))
                                        }, null, 8, ["field", "onUpdate", "onDelete"]))
                                      }), 128)),
                                      _createVNode(_component_v_btn, {
                                        size: "small",
                                        variant: "tonal",
                                        "prepend-icon": "mdi-plus",
                                        onClick: ($event: any) => (_ctx.addSchemaField(i))
                                      }, {
                                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                                          _createTextVNode("Add Field")
                                        ])),
                                        _: 2,
                                        __: [3]
                                      }, 1032, ["onClick"])
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_4, " This step's expected input is too advanced to edit here — manage it in Advanced. ")),
                                _createElementVNode("div", _hoisted_5, [
                                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-body-2 text-medium-emphasis" }, "If the data doesn't match,", -1)),
                                  _createVNode(_component_ChipSelect, {
                                    "model-value": s.fixerAgent || 'no one',
                                    options: _ctx.fixerOptions(s.fixerAgent),
                                    icon: "mdi-auto-fix",
                                    "onUpdate:modelValue": (v) => _ctx.setFixer(i, v)
                                  }, null, 8, ["model-value", "options", "onUpdate:modelValue"]),
                                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-body-2 text-medium-emphasis" }, "rewrites it, up to", -1)),
                                  _createVNode(_component_ChipSelect, {
                                    "model-value": String(s.maxRepairAttempts ?? 0),
                                    options: _ctx.repairAttemptOptions,
                                    "onUpdate:modelValue": (v) => _ctx.patchStep(i, { maxRepairAttempts: parseInt(v, 10) || 0 })
                                  }, null, 8, ["model-value", "options", "onUpdate:modelValue"]),
                                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-body-2 text-medium-emphasis" }, "times.", -1))
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_v_timeline_item, {
        "dot-color": "surface",
        size: "x-small"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            size: "small",
            color: "primary",
            "prepend-icon": "mdi-plus",
            onClick: _ctx.addStep
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode(" Add a step ")
            ])),
            _: 1,
            __: [8]
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}